$.prototype.isDescendantOf = function (ancestor_elt) {
  if(!typeof(ancestor_elt.has) == "function"){ throw TypeError; }
  if(ancestor_elt.has(this).length > 0 ){
    return true;
  }else{
    return false;
  }
}